import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductShowcase } from './components/ProductShowcase';
import { VolumesDetail } from './components/VolumesDetail';
import { BonusesSection } from './components/BonusesSection';
import { CountdownSection } from './components/CountdownSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { FooterSection } from './components/FooterSection';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    // Load fonts asynchronously — non-render-blocking
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = function () {
      ;
      (this as HTMLLinkElement).media = 'all';
    };
    document.head.appendChild(fontLink);
    // Preload hero image for faster LCP
    const preloadImg = document.createElement('link');
    preloadImg.rel = 'preload';
    preloadImg.as = 'image';
    preloadImg.href = 'https://cdn.magicpatterns.com/uploads/xreJrC7QZ2pqEundwF9PmH/Sin-titulo-_420-x-420-px_.webp';
    preloadImg.type = 'image/webp';
    document.head.insertBefore(preloadImg, document.head.firstChild);
    // Defer Meta Pixel to idle time
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => loadPixel(), {
        timeout: 10000
      });
    } else {
      setTimeout(loadPixel, 8000);
    }
  }, []);
  return <main className="font-body text-white bg-brand-dark overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <ProductShowcase data-id="element-3" />
      <VolumesDetail data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <CountdownSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTASection data-id="element-11" />
      <FooterSection data-id="element-12" />
      <PurchaseNotification data-id="element-13" />
    </main>;
}
function loadPixel() {
  if (typeof window !== 'undefined' && !(window as any).fbq) {
    const f = window as any;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '1170774765082882');
    (window as any).fbq('track', 'PageView');
  }
}